import { orderedRows, type ServitutReportState } from "../model/report";
import { toMatrixView } from "./matrixView";

export function toViewPayload(state: ServitutReportState) {
   return {
      caseDescription: state.caseDescription,
      aktSearchByBfe: state.aktSearchByBfe,
      matrix: {
         columns: state.columns,
         columnLabels: state.columnLabels,
         columnDetails: state.columnDetails,
         rows: orderedRows(state).map(toMatrixView),
      },
   };
}

export function toViewerAnalysisResult(
   item: ServitutReportState["rows"][string]["analysis"],
   mode: "summary" | "full",
) {
   if (!item?.item) {
      return undefined;
   }
   const full = item.item;
   const summary = {
      id: full.id,
      aktId: full.aktId,
      processing_method: full.processing_method,
      reasoning: full.reasoning,
      pages_kept: full.pages_kept,
      original_pages: full.original_pages,
      extracted_pages: full.extracted_pages,
      summary: full.summary,
      confidence: full.confidence,
      overall_confidence: full.overall_confidence,
      overall_confidence_reasoning: full.overall_confidence_reasoning,
      needs_review: full.needs_review,
      review_reasons: full.review_reasons,
   };
   return {
      items: [mode === "summary" ? summary : full],
      total_processed: 1,
      total_requested: 1,
      timestamp: new Date().toISOString(),
   };
}
